import React, { useState, useRef } from "react";
import { Box, Typography, Button, LinearProgress, IconButton } from "@mui/material";
import uploadIcon from './../../assets/images/signin/Upload icon.png';
import ActionButton from "./ActionButton/ActionButton";
import FileUpload from "../FileUpload/FileUpload";
const Step3 = ({ uploadedFiles, setUploadedFiles, handleFileSelect, handleBack, handleNext, t, direction, handleDrop }) => {
  const [unsupportedFiles, setUnsupportedFiles] = useState([]);
  const fileInputRef = useRef(null);
  const handleUploadClick = () => {
    fileInputRef.current.click();
  };
  // Supported file types
  const supportedFileTypes = ["image/jpeg", "image/png", "image/gif", "video/mp4", "application/pdf", "application/vnd.adobe.photoshop", "application/psd"];
  // Determine if there are any unsupported files
  const hasUnsupportedFiles = unsupportedFiles.length > 0;

  return (
    <Box sx={direction = { direction }}>
      <Typography
        sx={{
          fontWeight: 500,
          color: "#000",
          marginBottom: 1,
          fontSize: "18px",
          paddingBottom: "16px",
        }}
      >
        {t.addAttachments}
      </Typography>

      <FileUpload
        onFileSelect={handleFileSelect}
        supportedFileTypes={supportedFileTypes}
        uploadedFiles={uploadedFiles}
        setUploadedFiles={setUploadedFiles}
        uploadIcon={uploadIcon}
        fileInputRef={fileInputRef}
        buttonLabel={t.browse}
        t={t}
        onDrop={handleDrop}
      />


      <Box sx={{ justifyContent: "center", display: "flex", alignItems: "center" }}>
        {/* Action Buttons */}
        <Button
          variant="contained"
          onClick={handleUploadClick}
          sx={{
            backgroundColor: "#0D4975",
            fontSize: "16px",
            fontWeight: 600,
            textTransform: "none",
            opacity: "50%",
            padding: "10px 80px",
          }}
        >
          {t.uploadFiles}
        </Button>
      </Box>

      <Box sx={{ display: "flex", justifyContent: "space-between", marginTop: "16px", flexDirection: { xs: "column", md: "row" },direction:"ltr" }}>
        <ActionButton onClick={handleBack} label={t.back} color="var(--back-color)" />
        <ActionButton
          onClick={handleNext}
          label={t.next}
          color="var(--primary-color)"
          hovercolor="var(--primary-color-dark)"
          disabled={hasUnsupportedFiles}
        />


      </Box>
    </Box>
  );
};

export default Step3;
